// extracted by mini-css-extract-plugin
export default {"pastBorder":"pastBorder--emZ3N","blurOverlay":"blurOverlay--taV9h","zoneTitle":"zoneTitle--_gqTR"};